/* prettier-ignore-file */

import * as React from 'react';
import { Grid, Stack, Typography, useTheme, useMediaQuery } from '@mui/material';
import PublicLayout from '../../../bidder/layouts/PublicLayout';

const AboutUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // prettier-ignore
  const SpanishContent = () => (
    <Grid item xs={12} md={6}>
      <Stack spacing={2}>
        <Typography variant={'h3'}>Sobre Bidder®</Typography>
        <Typography variant={'body1'}>
          Bienvenido a Bidder®, el portal de licitaciones desarrollado por FMHOUSE para
          transformar la manera en que clientes y proveedores interactúan en la contratación de
          servicios de Facility Management.
          Bidder® es un sistema online basado en tecnología Blockchain, que garantiza la
          seguridad, la transparencia y la trazabilidad completa de todas las actividades y del
          intercambio de información.
          Es la primera aplicación de su categoría que permite certificar todo el proceso de
          licitación, asegurando la integridad de cada paso.
          La plataforma ofrece información en tiempo real y ha sido diseñada para facilitar una
          interacción ágil, sencilla y eficiente entre todos los stakeholders implicados.
        </Typography>
        <Typography variant={'h3'}>Sobre FMHOUSE</Typography>
        <Typography variant={'body1'}>
          FMHOUSE es una empresa independiente, referente nacional e internacional en
          consultoría estratégica, formación e investigación en Facility Management.
          Nuestro compromiso es impulsar esta disciplina y a los profesionales que forman parte
          de ella, para que ocupen el lugar que merecen en el mercado y en las organizaciones.
          Al contratar un proyecto con FMHOUSE, obtiene un socio experto, con un equipo
          propio altamente capacitado y metodologías de trabajo consolidadas, que garantizan
          resultados de la máxima calidad.
          Nuestro enfoque asegura que las propuestas y soluciones que presentamos sean
          siempre pertinentes, innovadoras y alineadas con las necesidades actuales del sector.
        </Typography>
      </Stack>
    </Grid>
  );

  // prettier-ignore
  const EnglishContent = () => (
    <Grid item xs={12} md={6}>
      <Stack spacing={2} sx={{ height: '100%' }}>

      <Typography variant={'h3'}>About Bidder®</Typography>
        <Typography variant={'body1'}>
          Welcome to Bidder®, the tendering portal developed by FMHOUSE to transform the
          way clients and suppliers interact in the procurement of Facility Management
          services.
          Bidder® is an online system based on Blockchain technology, ensuring security,
          transparency, and full traceability of all activities and information exchange.
          It is the first application of its kind to certify the entire tender process, guaranteeing
          the integrity of every step.
          The platform provides real-time information and has been designed to facilitate agile,
          simple, and efficient interaction among all involved stakeholders.
        </Typography>
        <Typography variant={'h3'}>About FMHOUSE</Typography>
        <Typography variant={'body1'}>
          FMHOUSE is an independent company, a national and international benchmark in
          strategic consulting, training, and research in Facility Management.
          Our commitment is to promote this discipline and the professionals within it so they
          occupy the place they deserve in the market and in organizations.
          When you contract a project with FMHOUSE, you gain an expert partner with a highly
          skilled in-house team and well-established work methodologies that guarantee top-
          quality results.
          Our approach ensures that the proposals and solutions we present are always
          relevant, innovative, and aligned with the current needs of the sector.
        </Typography>
      </Stack>
    </Grid>
  );

  return (
    <>
      <PublicLayout title="About Us">
        <Grid
          container
          rowSpacing={3}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          direction={isMobile ? 'column' : 'row'}>
          <SpanishContent />
          <EnglishContent />
        </Grid>
      </PublicLayout>
    </>
  );
};

export default AboutUs;
